import { Button, Divider } from 'antd';
import { useHistory } from 'react-router-dom';
import { useWorkorderChecklistContext } from '../WorkorderChecklistProvider';
import { WorkorderChecklistItemType } from '../WorkorderChecklistProvider/WorkorderChecklistProvider.types';
import ChecklistEmailButton from './ChecklistEmailButton';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useWorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { useDiagnosticDetail } from '@/core/domain/workorder/Diagnostics/Diagnostics.hooks';
import { useReportChecklistQuery } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import ChecklistWhatsAppButton from './ChecklistWhatsAppButton';
import ChecklistPrintButton from './ChecklistPrintButton';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const WorkorderChecklistFooter: React.FC = () => {
  const history = useHistory();

  const { checklistItemId, workorderId, checklistItemType } =
    useWorkorderChecklistContext();

  const { data: workorder } = useWorkOrder(
    checklistItemType === WorkorderChecklistItemType.Workorder
      ? workorderId
      : undefined,
  );
  const { data: diagnostic } = useDiagnosticDetail(
    checklistItemType === WorkorderChecklistItemType.Diagnostic
      ? checklistItemId
      : undefined,
  );

  const checklistReport = useReportChecklistQuery({
    diagnosticId:
      checklistItemType === WorkorderChecklistItemType.Diagnostic
        ? checklistItemId
        : undefined,
    workOrderComplementId:
      checklistItemType === WorkorderChecklistItemType.Workorder
        ? checklistItemId
        : undefined,
  });

  const hasVehicle =
    checklistItemType === WorkorderChecklistItemType.Diagnostic
      ? !!diagnostic?.vehicle?.licensePlate
      : !!workorder?.vehicle?.licensePlate;

  const printVisibleChecklist = !hasPermissions([
    Authorities.MOVIMENTATION_WORKORDER_VIEW_CHECKLIST,
  ]);

  return (
    <>
      <Divider />
      <SpaceForButton>
        <Button
          onClick={() => {
            history.push(
              checklistItemType === WorkorderChecklistItemType.Diagnostic
                ? `/app/movements/diagnostics/${checklistItemId}`
                : `/app/movements/workOrders/${workorderId}/complements/${checklistItemId}/generalInfo`,
            );
          }}
          block
        >
          Voltar
        </Button>

        <ChecklistEmailButton
          disabled={!hasVehicle || !checklistReport.data?.company}
          tooltipMessage={
            hasVehicle && !checklistReport.data?.company
              ? 'Não há dados de checklist'
              : undefined
          }
        />

        <ChecklistWhatsAppButton
          disabled={!hasVehicle || !checklistReport.data?.company}
          tooltipMessage={
            hasVehicle && !checklistReport.data?.company
              ? 'Não há dados de checklist'
              : undefined
          }
        />

        <ChecklistPrintButton
          disabled={
            !hasVehicle ||
            !checklistReport.data?.company ||
            printVisibleChecklist
          }
          companyId={workorder?.company.id || diagnostic?.company.id}
          loading={checklistReport.isLoading}
          tooltipMessage={
            !hasVehicle
              ? 'Não há veículo vinculado'
              : !checklistReport.data?.company
              ? 'Não há dados de checklist'
              : printVisibleChecklist
              ? 'Você não tem permissão para imprimir o checklist'
              : undefined
          }
        />
      </SpaceForButton>
    </>
  );
};

export default WorkorderChecklistFooter;
